import * as React from "react";

import { Clazz } from "../../types";
import { Space, TextInput } from "../../styled-component";
import CRUDModal, { CRUDModalProps } from "../../common/components/CRUDModal";
import Text from "../common/Text";
import ClazzService from "../../services/Clazz";

const DEFAULT_VALUES = { name: "", code: "" };

export type CreateOrUpdateClazzProps = Omit<CRUDModalProps<Clazz>, "service">;

const service = new ClazzService();

function CreateOrUpdateClazz({ ...rest }: CreateOrUpdateClazzProps) {
  const getButtonTitle: CRUDModalProps<Clazz>["getButtonTitle"] = (
    _clazz,
    { isNew } = {}
  ) => (isNew ? "Create Class" : "Edit Class");

  const getModalTitle: CRUDModalProps<Clazz>["getModalTitle"] = (
    clazz,
    { isNew } = {}
  ) => (isNew ? "New Class" : clazz?.name || clazz?.url || "|");

  const getDefaultValues: CRUDModalProps<Clazz>["getDefaultValues"] = (clazz) =>
    clazz || DEFAULT_VALUES;

  return (
    <CRUDModal<Clazz>
      {...rest}
      getButtonTitle={getButtonTitle}
      getModalTitle={getModalTitle}
      getDefaultValues={getDefaultValues}
      service={service}
      renderForm={({ setValue, watch, isNew, isDisabled }) => {
        const name = watch("name");
        const code = watch("code");

        return (
          <>
            <Text.Label>Name</Text.Label>
            <TextInput
              autoFocus={isNew}
              editable={!isDisabled}
              onChangeText={(nextName) => setValue("name", nextName)}
              value={name}
            />

            <Space />

            <Text.Label>Code</Text.Label>
            <TextInput
              editable={!isDisabled && isNew}
              onChangeText={(nextCode) => setValue("code", nextCode)}
              value={code}
            />
          </>
        );
      }}
    />
  );
}

export default CreateOrUpdateClazz;
